import React from 'react';
import { getPreFilledKpiInfo } from '../../../../../../services/kpiService';
import {KpiInfo, KpiProps} from "../../../../../../types/types";
import {snakeCaseToWorld} from "../../../../../../utils/utils";
import "./PrefillKPICard.css"


export interface KPICardInfo {
    KPICardInfo: KpiInfo;
    closeModal: ()=>void;
}

const PrefillKPICard: React.FC<KPICardInfo & KpiProps> = (props): JSX.Element => {

    const setKpiInfo = () => {
        props.setKpiInfo(getPreFilledKpiInfo(props.KPICardInfo));
        props.closeModal()
    }

    return (
        <div
            onClick={setKpiInfo}
             className={"pointer kpi-box"}>
            <h2>{snakeCaseToWorld(props.KPICardInfo.name)}</h2>
            <p>{props.KPICardInfo.description}</p>
        </div>
    )
}


export default PrefillKPICard;
